/*
This component is matched with the nunjucks components: render-nav, nav-block-news, nav-block-products.
Every change made in this component should be checked and updated (if necessary) in its matching components and viceversa.
The things to be more careful about are the divs with the data attributes and the button with the title.
You should also check the search component just in case any change causes a malfunction, 
but the button in this component is not matched with this component.
*/

// Deleted closing when clicking outside the navigation

import { html } from "htm/preact"
import { useSignalEffect } from "@preact/signals"
import { useEffect, useState } from "preact/hooks"
import { openId } from "./state.js"


export default function NavItems({ menuDiv, id, text, btnDiv }) {
  const [active, setActive] = useState(false);

  useSignalEffect(() => {
    if (openId.value !== id) {
      setActive(false)
      btnDiv.parentElement.removeAttribute("data-active");
    }
  })

  const handleClick = () => {
    const header = document.querySelector("#header");
    if (active) {
      openId.value = ""
      setActive(false)
      btnDiv.parentElement.removeAttribute("data-active");
      header.removeAttribute("data-nav-open");
    } else {
      openId.value = id
      setActive(true)
      btnDiv.parentElement.setAttribute("data-active", "");
      header.setAttribute("data-nav-open", "");
    }
  }

  useEffect(() => {
    if (text) return;
    const btn = btnDiv.querySelector("button");

    btn.addEventListener("click", handleClick);
    return () => btn.removeEventListener("click", handleClick);
  }, [text, btnDiv, handleClick])

  useEffect(() => {
    if (active) btnDiv.parentElement.setAttribute("data-active", "")
    else btnDiv.parentElement.removeAttribute("data-active");
  }, [text, btnDiv, active])

  // This last useEffect won't be in this directory, it just don't have a place right now
  useEffect(() => {
    const header = document.querySelector("#header");
    
    // Generate a sentinel element positioned 100px from top to calculate pos
    let sentinel = document.querySelector("#scroll-sentinel");
    if (!sentinel) {
      sentinel = document.createElement("div");
      sentinel.id = "scroll-sentinel";
      document.body.insertBefore(sentinel, document.body.firstChild);
    }

    const observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          header.removeAttribute("data-hero-outside");
        } else {
          header.setAttribute("data-hero-outside", "");
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    }
  })

  useEffect(() => {
    const header = document.querySelector("#header");

    const handleOutsideClick = (event) => {
      const isOpen = header.hasAttribute("data-nav-open");
      if (!isOpen) return;

      const isSearchTrigger = event.target.closest('[data-search-trigger-island]');
      const isSearchModal = event.target.closest('pagefind-modal');
      const isHeaderClick = header.contains(event.target);

      if (isSearchTrigger) {
        header.removeAttribute("data-nav-open");
        openId.value = "";
        setActive(false);
        return;
      }

      if (!isHeaderClick && !isSearchModal) {
        header.removeAttribute("data-nav-open");
        openId.value = "";
        setActive(false);
      }
    }

    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [active]);

  if (text) {
    return html`
    <button type="button" onclick=${handleClick} class="transition-colors relative text-base h-16 lg:h-18 px-4 flex items-center gap-1 border-b-2 border-transparent {{ nav_item_text_base }} cursor-pointer group-data-nav-open:text-zinc-900 group-data-nav-mobile-open:text-zinc-100 group-data-hero-outside:text-zinc-900 group-data-active:border-red-500">
      <span>${text}</span>
    </button>`
  }
  return null;
}